var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f4706c881a87b4771acc2022c26cfc88060d1516"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["bridge128@bridge128-96"]={id:"f4706c881a87b4771acc2022c26cfc88060d1516"};
      